import React, { Fragment, useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Link } from "react-router-dom";
import Spinner from "../layout/Spinner";
import { connect } from "react-redux";
import { getReportbyId, getAllDevice } from "../../action/report";
import ReportHome from "./ReportHome";
import ReportSpace from "./ReportSpace";
import Alert from "../layout/Alert";
import UserInfo from "../dashboard/UserInfo";
import ResponsiveContentWrapper from "../layout/ResponsiveContentWrapper";
import AppButton from "../Common/Button/Button";
import { Box, Paper } from "@mui/material";

const Report = ({
  getReportbyId,
  getAllDevice,
  match,
  allDevice,
  report: { report, loading },
}) => {
  const { homeId } = useParams();
  const [user, setUser] = useState({});
  
  useEffect(() => {
    if (homeId) {
      getReportbyId(homeId);
    }
    
    setUser(JSON.parse(localStorage.getItem("userInfo")));
  }, [getReportbyId, homeId]);

  const goBack = () => {
    if (report && report.spaces && report.spaces.length > 0) {
      const deviceIds = report.spaces
        .filter((s) => s.devices && s.devices.length > 0)
        .flatMap((s) => s.devices.map((d) => d.deviceId));
      if (deviceIds.length > 0) {
        getAllDevice(deviceIds.join(","));
        return;
      }
    }
    getAllDevice("");
  };

  return (
    <Fragment>
      {report === null || loading ? (
        <Box sx={{ position: "absolute", top: "50%", left: "50%" }}>
          <Spinner />
        </Box>
      ) : (
        <Fragment>
          <ResponsiveContentWrapper className="report-page-wrapper">
            <Alert />
            <Box sx={{ mb: 2 }}>
              <AppButton
                component={Link}
                to="/dashboardBack"
                onClick={() => goBack()}
                variant="primary"
                size="medium"
              >
                Back
              </AppButton>
            </Box>
            <UserInfo user={user} />
            <Paper sx={{ p: 2, boxShadow: 2, borderRadius: 1, mt: 2 }}>
              {report && !report.hasOwnProperty("msg") ? (
                <Box>
                  <Box sx={{ mb: 2 }}>
                    <ReportHome report={report} />
                  </Box>
                  <ReportSpace
                    report={report}
                    getAllDevice={getAllDevice}
                    allDevice={allDevice}
                    homeId={homeId}
                  />
                </Box>
              ) : (
                <Box sx={{ textAlign: "center", py: 4 }}>
                  Data not Found
                </Box>
              )}
            </Paper>
          </ResponsiveContentWrapper>
        </Fragment>
      )}
    </Fragment>
  );
};

const mapStateToProps = (state) => ({
  report: state.report,
  allDevice: state.report.allDevice,
});

export default connect(mapStateToProps, { getReportbyId, getAllDevice })(Report);
